/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback } from 'react'

import { Form, Select } from 'antd'
import { Rule } from 'antd/lib/form'

const { Option } = Select

export interface SelectItemProps {
  value: string
  label: string
  key?: string
  disabled?: boolean
  default?: boolean
}

interface SelectProps {
  methods: any
  scope: string
  name: string
  label?: string
  defaultValue?: any
  value?: string
  items: SelectItemProps[]
  onChangeValue?: (value: string) => void
  onSearch?: (value: string) => void
  searchValue?: string
  showSearch?: boolean
  filterOption?: any
  mode?: string
  rules?: Rule[]
  disabled?: boolean
  emptyValue?: boolean
  onClick?: any
  id?: string
}

export const SelectFieldAnt = ({
  methods,
  name,
  defaultValue,
  value,
  label,
  scope,
  items,
  onChangeValue,
  onSearch,
  searchValue,
  showSearch,
  filterOption,
  mode,
  rules,
  disabled,
  emptyValue,
  onClick,
  id,
}: SelectProps) => {
  const { register } = methods

  const handleChange = useCallback(
    (value: string) => {
      if (onChangeValue) onChangeValue(value)
    },
    [methods, name],
  )

  const createOptions = () => {
    const options = emptyValue
      ? [{ key: '', value: '', label: '', disabled: false }, ...items]
      : items

    return options.map((option) => (
      <Option
        key={option.key ? option.key : option.value}
        value={option.value}
        disabled={option.disabled}
      >
        {option.label}
      </Option>
    ))
  }

  const defaultFilterOption = (input: any, option: any) => {
    return (option?.children ?? '').toUpperCase().includes(input.toUpperCase())
  }

  return (
    <Form.Item name={name} label={label} rules={rules}>
      <Select
        id={id ?? `${scope}-input-${name}`}
        {...register(name)}
        defaultValue={defaultValue}
        value={value}
        onChange={handleChange}
        showSearch={showSearch}
        onSearch={onSearch}
        searchValue={searchValue}
        filterOption={filterOption ?? defaultFilterOption}
        mode={mode}
        disabled={disabled}
        onClick={onClick}
      >
        {createOptions()}
      </Select>
    </Form.Item>
  )
}
